import { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, verifyTotp, saveSession } from '../utils/auth';

const inputStyle = {
  width: '100%', padding: '12px', border: '1px solid #ddd',
  borderRadius: '4px', fontSize: '16px', boxSizing: 'border-box',
};
const btnStyle = (loading) => ({
  width: '100%', padding: '12px', background: '#db782e', color: 'white',
  border: 'none', borderRadius: '4px', fontSize: '16px', cursor: 'pointer',
  marginTop: '15px', opacity: loading ? 0.7 : 1,
});

const PreviewAuth = () => {
  const [password, setPassword]   = useState('');
  const [totpCode, setTotpCode]   = useState('');
  const [tempToken, setTempToken] = useState(null);
  const [error, setError]         = useState('');
  const [loading, setLoading]     = useState(false);
  const navigate = useNavigate();
  const totpRef = useRef(null);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await login(password);
      if (result.requireTotp) {
        setTempToken(result.tempToken);
        setTimeout(() => totpRef.current?.focus(), 50);
      } else {
        saveSession(result);
        navigate('/preview');
      }
    } catch {
      setError('Неверный пароль!');
    } finally {
      setLoading(false);
    }
  };

  const handleTotp = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const result = await verifyTotp(tempToken, totpCode);
      saveSession(result);
      navigate('/preview');
    } catch (err) {
      setError(err.message || 'Неверный код');
      setTotpCode('');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#f5f5f5', margin: 0, padding: 0 }}>
      <div style={{ background: 'white', padding: '40px', borderRadius: '8px', boxShadow: '0 4px 20px rgba(0,0,0,0.1)', maxWidth: '400px', width: '100%' }}>
        {!tempToken ? (
          <>
            <h2 style={{ textAlign: 'center', marginBottom: '20px' }}>🔐 Доступ к превью</h2>
            <p style={{ textAlign: 'center', color: '#666', marginBottom: '20px' }}>
              Введите пароль для просмотра предварительной версии сайта
            </p>
            <form onSubmit={handleLogin}>
              <input
                type="password"
                value={password}
                onChange={(e) => { setPassword(e.target.value); setError(''); }}
                placeholder="Введите пароль"
                required
                style={inputStyle}
              />
              {error && <p style={{ color: 'red', fontSize: '14px', marginTop: '10px' }}>{error}</p>}
              <button type="submit" disabled={loading} style={btnStyle(loading)}>
                {loading ? 'Проверяем...' : 'Войти в превью'}
              </button>
            </form>
          </>
        ) : (
          <>
            <h2 style={{ textAlign: 'center', marginBottom: '8px' }}>🔑 Двухфакторная аутентификация</h2>
            <p style={{ textAlign: 'center', color: '#666', fontSize: '14px', marginBottom: '20px' }}>
              Введите код из Google Authenticator
            </p>
            <form onSubmit={handleTotp}>
              <input
                ref={totpRef}
                type="text"
                inputMode="numeric"
                pattern="[0-9 ]*"
                value={totpCode}
                onChange={(e) => { setTotpCode(e.target.value); setError(''); }}
                placeholder="000 000"
                required
                autoComplete="one-time-code"
                style={{ ...inputStyle, textAlign: 'center', fontSize: '24px', letterSpacing: '6px' }}
              />
              {error && <p style={{ color: 'red', fontSize: '14px', marginTop: '10px' }}>{error}</p>}
              <button type="submit" disabled={loading} style={btnStyle(loading)}>
                {loading ? 'Проверяем...' : 'Подтвердить'}
              </button>
              <button
                type="button"
                onClick={() => { setTempToken(null); setPassword(''); setError(''); }}
                style={{ width: '100%', padding: '10px', background: 'none', border: 'none', color: '#999', fontSize: '14px', cursor: 'pointer', marginTop: '10px' }}
              >
                ← Назад
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default PreviewAuth;
